import type { ProvinceDef } from '../types';

export const PROVINCE_DEFS: ProvinceDef[] = [
  { key: '北京', full: '北京市', label: 'Beijing' },
  { key: '天津', full: '天津市', label: 'Tianjin' },
  { key: '上海', full: '上海市', label: 'Shanghai' },
  { key: '重庆', full: '重庆市', label: 'Chongqing' },
  { key: '河北', full: '河北省', label: 'Hebei' },
  { key: '山西', full: '山西省', label: 'Shanxi' },
  { key: '辽宁', full: '辽宁省', label: 'Liaoning' },
  { key: '吉林', full: '吉林省', label: 'Jilin' },
  { key: '黑龙江', full: '黑龙江省', label: 'Heilongjiang' },
  { key: '江苏', full: '江苏省', label: 'Jiangsu' },
  { key: '浙江', full: '浙江省', label: 'Zhejiang' },
  { key: '安徽', full: '安徽省', label: 'Anhui' },
  { key: '福建', full: '福建省', label: 'Fujian' },
  { key: '江西', full: '江西省', label: 'Jiangxi' },
  { key: '山东', full: '山东省', label: 'Shandong' },
  { key: '河南', full: '河南省', label: 'Henan' },
  { key: '湖北', full: '湖北省', label: 'Hubei' },
  { key: '湖南', full: '湖南省', label: 'Hunan' },
  { key: '广东', full: '广东省', label: 'Guangdong' },
  { key: '海南', full: '海南省', label: 'Hainan' },
  { key: '四川', full: '四川省', label: 'Sichuan' },
  { key: '贵州', full: '贵州省', label: 'Guizhou' },
  { key: '云南', full: '云南省', label: 'Yunnan' },
  { key: '陕西', full: '陕西省', label: 'Shaanxi' },
  { key: '甘肃', full: '甘肃省', label: 'Gansu' },
  { key: '青海', full: '青海省', label: 'Qinghai' },
  { key: '台湾', full: '台湾省', label: 'Taiwan' },
  { key: '内蒙古', full: '内蒙古自治区', label: 'Inner Mongolia' },
  { key: '广西', full: '广西壮族自治区', label: 'Guangxi' },
  { key: '西藏', full: '西藏自治区', label: 'Tibet' },
  { key: '宁夏', full: '宁夏回族自治区', label: 'Ningxia' },
  { key: '新疆', full: '新疆维吾尔自治区', label: 'Xinjiang' },
  { key: '香港', full: '香港特别行政区', label: 'Hong Kong' },
  { key: '澳门', full: '澳门特别行政区', label: 'Macau' },
];

const PROVINCE_ALIAS_TO_KEY: Record<string, string> = {};
for (const item of PROVINCE_DEFS) {
  PROVINCE_ALIAS_TO_KEY[item.full] = item.key;
  PROVINCE_ALIAS_TO_KEY[item.key] = item.key;
  PROVINCE_ALIAS_TO_KEY[item.label] = item.key;
}

export const PROVINCE_LABEL_MAP: Record<string, string> = {};
for (const item of PROVINCE_DEFS) {
  PROVINCE_LABEL_MAP[item.key] = item.label;
}

export const PROVINCE_GEO_MAP: Record<string, string> = {};
for (const item of PROVINCE_DEFS) {
  PROVINCE_GEO_MAP[item.key] = item.full;
}

export const CHINA_MAP_NAME_MAP: Record<string, string> = {};
for (const item of PROVINCE_DEFS) {
  CHINA_MAP_NAME_MAP[item.full] = item.label;
}

export function normalizeProvinceKey(name: string): string {
  const text = String(name || '').trim();
  return PROVINCE_ALIAS_TO_KEY[text] || text;
}

export function toProvinceDisplayName(name: string): string {
  const key = normalizeProvinceKey(name);
  return PROVINCE_LABEL_MAP[key] || key || String(name || '--');
}

export function toProvinceGeoName(name: string): string {
  const key = normalizeProvinceKey(name);
  return PROVINCE_GEO_MAP[key] || key || String(name || '');
}
